import compileVariableUtil from '../../static/js/compileVariableUtil'
import templateUtil from '../../static/js/templateUtil'
export default {
  name: 'portalItemDynamic',
  props: {
    portalItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {}
  },
  render(h) {
    if (!this.portalItem || !this.portalItem.component || !this.portalItem.component.code) {
      console.error('未配置组件')
      return
    }
    const compontentName = this.portalItem.component.code
    const propsCompileData = compileVariableUtil.getCompileVariable({}, this)
    let _props = Object.assign({ title: this.portalItem.title }, this.portalItem.parameter)
    let propsCompile = null
    try {
      propsCompile = templateUtil.compileData(_props, propsCompileData)
    } catch (e) {
      propsCompile = _props
    }
    return h(compontentName, {
      props: propsCompile,
      style: {
        width: this.portalItem.width ? this.portalItem.width + 'px' : 'auto',
        height: this.portalItem.height ? this.portalItem.height + 'px' : 'auto',
      },
    })
  },
}
